export default {
    女装: "Kasuotang Pambabae",
    男装: "Damit ng Lalaki",
    手机和小工具: "Mobile at Mga Gadget",
    居家生活: "Tahanan at Pamumuhay",
    电脑及周边设备: "Mga Computer at Peripheral",
    美容及个人护理: "Kagandahan at Personal na Pangangalaga",
    家用电器: "Mga gamit sa bahay",
    健康与保健: "Kalusugan at Kaayusan",
    食品和饮料: "Pagkain at Inumin",
    玩具_儿童和婴儿: "Mga Laruan, Bata at Sanggol",
    童装时尚: "Fashion ng mga Bata",
    视频游戏: "Mga Video Game",
    运动与户外: "Palakasan at Panlabas",
    爱好与书籍: "Mga Libangan at Aklat",
    相机和无人机: "Mga Camera at Drone",
    宠物食品及用品: "Pagkain at Kagamitan ng Alagang Hayop",
    女士包袋: "Mga Bag na Pambabae",
    男士包袋: "Mga Bag ng Lalaki",
    珠宝及配饰: "Alahas at Accessory",
    手表: "Mga relo",
    女鞋: "Sapatos ng babae",
    男装鞋: "Sapatos na panglalaki",
    汽车: "Automotive",
    我附近的ShopeePay: "ShopeePay Malapit sa Akin",
    餐饮_旅行和服务: "Kainan, Paglalakbay at Serbisyo",
    旅行及行李: "Paglalakbay at Luggage",
    各种各样的: "Miscellaneous",
    我是来买什么的: "Ano ang bibilhin ko dito?",
    对不起_找不到_相关的商品: "Paumanhin, walang nakitang mga produktong nauugnay sa [{0}].",
    类别: "Kategorya",
    产品: "Produkto",
    店铺: "Tindahan",
    首页: "Unang pahina",
    限时秒杀: "Limitadong oras ng flash sale",
    博客: "Blog",
    所有品牌: "Lahat ng brand",
    所有类别: "Lahat ng kategorya",
    我的购物车: "Ang shopping cart ko",
    发货信息: "Impormasyon sa paghahatid",
    交货信息: "Impormasyon sa paghahatid",
    付款: "Pagbabayad",
    确认: "Kumpirmahin",
    您的购物车是空的: "Ang iyong shopping cart ay walang laman",
    价格: "Presyo",
    税: "Buwis",
    数量: "Dami",
    总计: "Kabuuan",
    移除: "Alisin",
    返回商店: "Bumalik sa tindahan",
    继续发货: "Magpatuloy sa pagpapadala",
    筛选: "Salain",
    价格范围: "Hanay ng presyo",
    排序方式: "Ayusin ayon sa",
    最新: "Napapanahon",
    最旧: "Pinakamatanda",
    价格从低到高: "Presyo mula mababa hanggang mataas",
    价格从高到低: "Presyo mula mataas hanggang mababa",
    选择交货类型: "Piliin ang uri ng paghahatid",
    送货上门: "Paghahatid",
    继续付款: "Ipagpatuloy ang pagbabayad",
    任何其他信息: "Anumang iba pang impormasyon",
    或者: "O",
    您的钱包余额: "Ang iyong balanse sa wallet",
    余额不足: "Hindi sapat na balanse",
    支付: "Magbayad",
    我同意: "Sumasang-ayon ako",
    条款和条件: "Mga tuntunin at Kundisyon",
    退货政策: "Patakaran sa Pag sauli",
    隐私政策: "Patakaran sa Privacy",
    概括: "Gawing pangkalahatan",
    项目: "Proyekto",
    全部的: "Lahat",
    小计: "Subtotal",
    总运费: "Kabuuang gastos sa pagpapadala",
    有优惠码吗_在这里输入: "May discount code ba? pumasok dito",
    申请: "Mag-apply",
    编辑: "I-edit",
    删除: "Tanggalin",
    添加新地址: "Magdagdag ng bagong address",
    继续交货信息: "Ipagpatuloy ang paghahatid ng impormasyon",
    选择一个地址: "Pumili ng isang address",
    购买历史: "Kasaysayan ng pagbili",
    下载: "Download",
    已发送退款请求: "Ipinadala ang kahilingan sa refund",
    对比: "Kumpara",
    对话: "Diyalogo",
    我的钱包: "Ang pitaka ko",
    工单: "Order sa trabaho",
    管理个人资料: "Pamahalaan ang profile",
    登出: "Mag-sign out",
    重置对比列表: "I-reset ang listahan ng paghahambing",
    您的对比列表为空: "Walang laman ang iyong listahan ng paghahambing",
    在您的购物车中: "Sa iyong shopping cart",
    在您的愿望清单中: "Sa wish list mo",
    在您的预定列表中: "Sa iyong listahan ng booking",
    下载您的产品: "I-download ang iyong produkto",
    选项: "Mga pagpipilian",
    什么都没找到: "Walang nahanap",
    特色产品: "Mga Itinatampok na Produkto",
    最畅销: "Pinakamahusay na nagbebenta",
    前_名: "Nangungunang {0}",
    查看更多: "Tingnan pa",
    查看所有类别: "Tingnan ang lahat ng mga kategorya",
    十大品牌: "Nangungunang sampung tatak",
    查看所有品牌: "Tingnan ang lahat ng mga tatak",
    登录: "Mag log in",
    手机号码: "Numero ng telepono",
    密码: "Password",
    密码长度为6到16个字符: "Ang haba ng password ay 6 hanggang 16 na character",
    验证码: "Verification code",
    登录中: "Mag log in",
    游客登录: "Pag-login ng bisita",
    注册您的商店: "Irehistro ang iyong tindahan",
    现在申请: "Mag-apply ngayon",
    成为商家: "Maging isang mangangalakal",
    现在注册: "Mag-rehistro na ngayon",
    登录成功: "Matagumpay na nakarating",
    通知: "Ipaalam",
    未找到通知: "Hindi nahanap ang notification",
    评论: "Magkomento",
    估计运输时间: "Tinatayang oras ng pagpapadala",
    天: "Langit",
    所售: "Naibenta",
    给商家留言: "Mag-iwan ng mensahe sa merchant",
    规格: "Pagtutukoy",
    库存: "Nasa stock",
    总价: "Kabuuang presyo",
    添加到购物车: "Idagdag sa Cart",
    立即购买: "Bilhin mo na",
    缺货: "Out of stock",
    添加到愿望清单: "Idagdag sa listahan ng kahilingan",
    加入对比列表: "Idagdag sa listahan ng paghahambing",
    退款: "Refund",
    查看条款: "Tingnan ang mga tuntunin",
    分享: "Ibahagi",
    描述: "Ilarawan",
    相关产品: "Kaugnay na Mga Produkto",
    没有人问过商家: "Walang nagtanong sa mga mangangalakal",
    该产品暂无评论: "Wala pang mga review para sa produktong ito",
    客户评论: "Mga review ng customer",
    访问商店: "Bisitahin ang tindahan",
    畅销产品: "Pinaka mabenta",
    日期: "Petsa",
    订单编号: "Numero ng order",
    总额: "Kabuuan",
    状态: "Estado",
    愿望清单: "Wishlist",
    还没有添加任何东西: "Wala pang nadagdag",
    注册: "Magparehistro",
    邀请码: "Code ng imbitasyon",
    请输入邀请码: "Pakilagay ang code ng imbitasyon",
    用户名: "Username",
    请输入用户名: "Pakilagay ang user name",
    用户名长度为6_14个字符: "Ang haba ng username ay 6-14 na character",
    昵称: "Palayaw",
    请输入手机号码: "Mangyaring ipasok ang numero ng telepono",
    手机号码格式错误: "Maling format ng numero ng telepono",
    密码长度为6_16个字符: "Ang haba ng password ay 6-16 na character",
    确认密码: "Kumpirmahin ang Password",
    请输入确认密码: "Mangyaring ipasok ang password sa pagkumpirma",
    提款密码: "Pag-withdraw ng password",
    请输入提款密码: "Mangyaring ipasok ang password sa pag-alis",
    提款密码长度为4_16个字符: "Ang haba ng withdrawal na password ay 4-16 character",
    请输入验证码: "Pakilagay ang verification code",
    在_s后发送: "Ipinadala pagkatapos ng {0}s",
    发送验证码: "Ipadala ang verification code",
    注册即表示您同意我们的条款和条件: "Sa pamamagitan ng pag-sign up sumasang-ayon ka sa aming mga tuntunin at kundisyon.",
    创建账号: "Gumawa ng account",
    验证码发送成功: "Matagumpay na naipadala ang verification code",
    确认密码不一致: "Kumpirmahin na hindi pare-pareho ang password",
    提款密码必须为数字: "Ang password sa pag-withdraw ay dapat na numero",
    注册成功: "Tagumpay sa pagpaparehistro",
    购物车: "Shopping cart",
    账户: "Account",
    我的账户: "Aking Account",
    已经有一个账户: "Mayroon nang account",
    新地址: "Bagong tirahan",
    编辑地址: "I-edit ang address",
    保存: "Iligtas",
    是否默认: "Ito ba ang default",
    具体地址: "Tukoy na address",
    请输入具体地址: "Mangyaring magpasok ng partikular na address",
    地区: "Lugar",
    请输入地区: "Mangyaring ipasok ang rehiyon",
    城市: "Lungsod",
    请输入城市: "Mangyaring ipasok ang lungsod",
    省份: "Lalawigan",
    请输入省份: "Mangyaring pumasok sa lalawigan",
    邮政编码: "Postal code",
    请输入邮政编码: "Mangyaring ipasok ang postal code",
    电话号码: "Numero ng telepono",
    请输入电话号码: "Pakibigay na lng po ng phone number niyo",
    收货人: "Receiver",
    请输入收货人: "Mangyaring ipasok ang consignee",
    保存成功: "Matagumpay na na-save",
    最畅销的商家: "Pinakamabentang Merchant",
    查看所有的商家: "Tingnan ang lahat ng negosyo",
    支持政策: "Patakaran sa suporta",
    您的电子邮件地址: "Ang iyong email address",
    订阅: "Subscription",
    联系方式: "Impormasyon sa pakikipag-ugnayan",
    地址: "Address",
    美国伊利诺伊州霍夫曼庄园: "Hoffman Estates, Illinois, USA",
    快速链接: "Mga Mabilisang Link",
    商家政策: "Mga patakaran ng merchant",
    submit: "Ipasa",
    提款银行卡: "Pag-withdraw ng bank card",
    我的面板: "Ang panel ko",
    提示: "Pahiwatig",
    确定登出吗: "Sigurado ka bang gusto mong mag-log out?",
    确定: "Oo naman",
    取消: "Kanselahin",
    项目添加到您的购物车: "Magdagdag ng item sa iyong shopping cart",
    经常一起购买: "Madalas sabay bumili",
    返回购物: "Bumalik sa pamimili",
    进行结算: "Magpatuloy sa pag-checkout",
    帮助热线: "Helpline",
    查看所有通知: "Tingnan ang lahat ng notification",
    请输入密码: "Mangyaring ipasok ang password",
    前往充值: "Pumunta sa recharge",
    购物车物品: "Mga item sa shopping cart",
    查看购物车: "Tingnan ang shopping cart",
    钱包余额: "Balanse ng pitaka",
    充值钱包: "Mag-recharge ng wallet",
    钱包充值_线下_: "Mag-recharge ng wallet (offline)",
    申请提款: "Mag-apply para sa withdrawal",
    钱包收支明细: "Mga Detalye ng Kita at Paggasta ng Wallet",
    批准: "Aprubahan",
    提现历史记录: "Kasaysayan ng pag-withdraw",
    类型: "Uri",
    信息: "Impormasyon",
    付款方式: "Paraan ng Pagbayad",
    请选择付款方式: "Mangyaring pumili ng paraan ng pagbabayad",
    Bill_Type_RECHARGE_BACK: "Backend recharge",
    Bill_Type_RECHARGE_ONLINE: "Online recharge",
    Bill_Type_RECHARGE_REGISTER: "Magrehistro nang libre",
    Bill_Type_RECHARGE_JACKPOT: "Recharge na bonus",
    Bill_Type_RECHARGE_PRESENT: "Mag-recharge ng mga reward",
    Bill_Type_RECHARGE_FROM_COMMISSION: "Paglipat ng komisyon",
    Bill_Type_RECHARGE_TG_COMMISSION: "Komisyon sa pag-recharge ng promosyon",
    Bill_Type_REGISTER_TG_COMMISSION: "Komisyon sa promosyon ng pagpaparehistro",
    Bill_Type_WITHDRAW: "Bawiin",
    Bill_Type_WITHDRAW_REJECT: "Tinanggihan ang withdrawal",
    Bill_Type_DEDUCT_HANDLE: "Manu-manong pagbabawas",
    Bill_Type_DEDUCT_RECHARGE_MONEY: "Pagwawasto ng muling pagkarga",
    Bill_Type_MINING_PROFIT: "Kita sa pagmimina",
    Bill_Type_MINING_PROFIT_COMMISSION: "Komisyon sa promosyon ng kita sa pagmimina",
    Bill_Type_VIP_UPGRADE: "I-upgrade ang VIP",
    Bill_Type_FINANCE_BUY: "Bumili ng mga produktong pinansyal",
    Bill_Type_FINANCE_CAPITAL_RETURN: "Pagbabalik ng balanse sa pananalapi",
    Bill_Type_FINANCE_FEE: "Mga bayarin sa pamamahala sa pananalapi",
    Bill_Type_FINANCE_PROFIT: "Kita sa pamamahala sa pananalapi",
    Bill_Type_FINANCE_BUY_COMMISSION: "Komisyon para sa pagbili ng mga produktong pinansyal",
    Bill_Type_FINANCE_PROFIT_COMMISSION: "Komisyon sa kita ng produktong pinansyal",
    Bill_Type_WHEEL_DRAW: "Malaking gulong lottery",
    Bill_Type_BUY: "Bumili ng paninda",
    Bill_Type_PAY_SHOP: "Magbayad para sa pagpapadala",
    Bill_Type_BUY_COMMISSION: "Komisyon sa mga biniling bagay",
    Bill_Type_DEPOSIT: "Magbayad ng deposito",
    Bill_Type_STORE_BUY: "Bumili ng paninda",
    Bill_Type_STORE_BUY_REFUND: "Pagbili ng refund ng produkto",
    Bill_Type: "Uri ng pagbabago ng account",
    Before_Money: "Dating halaga",
    Deal_Money: "Halaga ng pagbabago ng account",
    After_Money: "Halaga pagkatapos",
    Bill_Time: "Oras ng pagbabago ng account",
    No_More_Data: "Wala nang data",
    Apply_Money: "Halaga ng Application",
    Apply_Time: "Oras ng aplikasyon",
    Withdraw_Info: "Bayad sa pangangasiwa: {fee}, pagdating: {money}",
    提款订单状态_CHECKING: "Nakabinbing pagsusuri",
    提款订单状态_TRANSFERRING: "Paglilipat",
    提款订单状态_PASS: "Nakumpirma",
    提款订单状态_REJECT: "Nadismiss",
    暂无可用充值方式: "Wala pang magagamit na paraan ng pag-recharge",
    钱包收款码: "Code ng pagbabayad sa pitaka",
    钱包地址: "Address ng pitaka",
    金额限制: "Limitasyon sa halaga",
    复制: "Kopya",
    付款凭证: "Voucher sa pagbabayad",
    收款银行: "Bangko ng Benepisyaryo",
    收款人: "Nagbabayad",
    收款账号: "Account number sa pagbabayad",
    付款银行: "Bangko sa pagbabayad",
    付款人: "Nagbabayad",
    付款账号: "Account sa pagbabayad",
    请输入付款银行: "Mangyaring ipasok ang bangko sa pagbabayad",
    请输入付款人: "Mangyaring ipasok ang nagbabayad",
    请输入付款账号: "Mangyaring ipasok ang numero ng account sa pagbabayad",
    请上传付款凭证: "Mangyaring mag-upload ng voucher sa pagbabayad",
    充值金额: "Recharge na halaga",
    请输入充值金额: "Pakilagay ang halaga ng recharge",
    submitting: "Isinusumite...",
    Confirm: "Ipasa",
    Commit_Success: "Matagumpay na naisumite",
    balanceType_BALANCE: "Balanse",
    balanceType_COMMISSION: "Komisyon",
    Balance: "Balanse ng account",
    Wash_Money: "Magdagdag ng mosaic",
    请选择银行账户: "Mangyaring pumili ng bank account",
    卡号类型: "Uri ng numero ng card",
    提现金额: "Kalakihan ng kinuha",
    提款金额: "Kalakihan ng kinuha",
    不能为空: "Hindi maaaring walang laman",
    金额不正确: "Mali ang halaga",
    please_input_withdraw_password: "Mangyaring ipasok ang password sa pag-alis",
    withdraw_password_format_error: "Dapat na 4-16 character ang withdrawal password",
    Fee: "Handling fee",
    实际到账: "Aktwal na pagdating",
    交易币种: "Pera ng transaksyon",
    原始密码: "Orihinal na password",
    confirm_password_error: "Ang password na ipinasok ng dalawang beses ay hindi tama",
    save_success: "Matagumpay na na-save",
    please_input: "Pasok",
    old_password: "Lumang password",
    new_password: "Bagong Password",
    please_input_confirm_password: "Pakikumpirma muli ang password",
    没有找到符合条件的商品: "Walang nakitang tumutugmang produkto",
    Search: "Paghahanap",
    全部: "Lahat",
    EnumGoodsOrderState_USER_PAY: "Naghihintay ng paghahatid",
    EnumGoodsOrderState_SHOP_PAY: "Naghahatid",
    EnumGoodsOrderState_SUCCESS: "Tapusin",
    EnumGoodsOrderState_CANCEL: "Kinansela",
    EnumGoodsOrderState_REFUND_SUCCESS: "Na-refund",
    订单号: "Numero ng order",
    用户名称: "User name",
    收益: "Kita",
    支付时间: "Oras ng pagbabayad",
    配送时间: "Oras ng paghatid",
    完成时间: "Kumpletong oras",
    发货: "Barko",
    全选: "Piliin lahat",
    物品已添加到愿望清单: "Idinagdag ang item sa listahan ng nais",
    物品已添加到比较列表: "Idinagdag ang item sa listahan ng paghahambing",
    购买成功提示: "Binabati kita, matagumpay ang iyong pagbili",
    订单列表: "Listahan ng order",
    商品名: "Pangalan ng Produkto",
    图片: "Larawan",
    没有品牌: "Walang tatak",
    基本信息: "Pangunahing Impormasyon",
    Account_Name: "Pangalan ng pagbubukas ng account",
    Bank_Account: "Bank account",
    Bank_Phone: "Magreserba ng numero ng mobile phone",
    IFSC: "IFSC account",
    UPI: "UPI",
    PIX: "PIX",
    CPF: "CPF",
    GCASH: "GCASH account",
    POWWI: "POWWI account",
    身份证号: "ID number",
    Edit: "Baguhin",
    Delete: "Tanggalin",
    Add: "Bago",
    Forget_Withdraw_Password: "Nakalimutan ang password sa pag-withdraw",
    Bank_Card_Info: "Impormasyon sa bank card",
    收款人地址: "Address ng nagbabayad",
    SWIFT: "SWIFT",
    Bank_Branch: "Pangalan ng sangay",
    分行代码: "Code ng sangay",
    银行地址: "Address ng bangko",
    Email: "Email",
    银行卡长度必须超过: "Ang haba ng bank card ay dapat lumampas sa {length}",
    银行卡格式不正确: "Mali ang format ng bank card",
    Do_you_confirm_delete: "Kumpirmahin ang pagtanggal?",
    Please_Login_First: "Paki log in muna",
    Bank_Name: "Pangalan ng bangko",
    Please_add_bank_first: "Hindi mo pa nakatali ang iyong bank card, mangyaring idagdag muna ito",
    withdrawType: "Uri ng pag-withdraw",
    withdraw_money_limit: "Ang halaga ng withdrawal ay dapat na mas malaki sa 0 at mas mababa sa o katumbas ng {balance}",
    withdraw_times_limit: "Nag-withdraw ka ng {todayWithdrawNum} (na) beses ngayon, at ang bayad sa pangangasiwa na {withdrawFee}% ay sisingilin pagkatapos ng {limitTimes} (na) beses. Sigurado ka bang mag-withdraw?",
    Copy_Success: "Matagumpay na nakopya",
    商店首页: "Homepage ng tindahan",
    所有产品: "Lahat ng produkto",
    新到货产品: "Mga bagong dating na produkto",
    所有商家: "Lahat ng mangangalakal",
    请上传: "Paki-upload",
    请输入: "Pasok",
    忘记密码: "Kalimutan ang password",
    记得我: "Tandaan mo ako",
    共_件: "Kabuuang {0} (na) item",
    取消订单: "Kanselahin ang order",
    申请退款: "Humiling ng refund",
    未知商家: "Hindi kilalang mangangalakal",
    到账: "Resibo",
    提款订单状态: "Status ng withdrawal order",
    前_名类别: "Nangungunang {0} mga kategorya",
    取消订单原因_不想要了: "Ayoko na",
    取消订单原因_商品错选_多选: "Maling pagpili ng produkto/maraming pagpili",
    取消订单原因_商品无货: "Out of stock ang produkto",
    取消订单原因_地址信息填写错误: "Ang impormasyon ng address ay napunan nang hindi tama",
    取消订单原因_商品降价: "Pagbabawas ng presyo ng produkto",
    取消订单原因_价格高于其他平台: "Ang presyo ay mas mataas kaysa sa iba pang mga platform",
    取消订单原因_没用_少用_错用优惠: "Walang paggamit/kaunting paggamit/maling paggamit ng mga diskwento",
    退款原因_拍错_多拍_不喜欢: "Wrong shot / extra shot / ayaw nito",
    退款原因_商品成分描述不符: "Hindi tugma ang paglalarawan ng sangkap ng produkto",
    退款原因_与商家协商一致退款: "Refund ayon sa napagkasunduan ng merchant",
    退款原因_生产日期_保质期与商品描述不符: "Ang petsa ng produksyon/buhay ng istante ay hindi tumutugma sa paglalarawan ng produkto",
    退款原因_图片_产地_批号_规格等描述不符: "Ang mga larawan/pinagmulan ng pinagmulan/batch number/mga detalye at iba pang paglalarawan ay hindi tugma",
    退款原因_质量问题: "Issue sa kalidad",
    退款原因_商品变质_发霉_有异物: "Ang produkto ay sira/may amag/may banyagang bagay",
    退款原因_少件_含缺少配件_: "Ilang piraso (kabilang ang mga nawawalang accessory)",
    退款原因_收到商品时有破损_污渍_变形: "Nasira/namantsa/deform ang item noong natanggap.",
    退款原因_假冒品牌: "Mga pekeng tatak",
    退款原因_发票问题: "Mga isyu sa invoice",
    退款原因_商家发错货: "Ang mangangalakal ay nagpadala ng mga maling kalakal",
    退款原因_预约不到_商家不给退换: "Hindi makagawa ng appointment/hindi ka bibigyan ng merchant ng refund o palitan",
    退款失败: "Nabigo ang refund",
    退款处理中: "Kasalukuyang isinasagawa ang refund",
    默认: "Default",
    产品查询: "Paghahanap ng Produkto",
    商店LOGO: "LOGO ng tindahan",
    推广码: "Code ng promosyon",
    查看所有: "Tingnan lahat",
    确认收货成功: "Kumpirmahin ang matagumpay na pagtanggap ng mga kalakal",
    物流公司: "Kumpanya ng logistik",
    物流单号: "Numero ng pagpapadala",
    发货时间: "Oras ng pagpapadala",
    请先选择商品规格: "Mangyaring pumili muna ng mga detalye ng produkto",
    个人信息: "Personal na impormasyon",
    您的用户名: "Ang iyong username",
    你的名字: "Ang pangalan mo",
    登录名: "Username",
    你的邮件: "Ang email mo",
    你的密码: "Ang iyong password",
    重复输入密码: "Ulitin ang password",
    店铺名称: "Pangalan ng Tindahan",
    证书类型: "Uri ng sertipiko",
    身份证: "ID card",
    护照: "Pasaporte",
    驾驶执照: "Lisensya sa pagmamaneho",
    社会保障卡: "Social security card",
    证书正面: "Sertipiko sa harap",
    证书反面: "Reverse side ng certificate",
    确认收货: "Kumpirmahin ang pagtanggap ng mga kalakal",
    请选择取消订单的原因必选: "Pakipili ang dahilan ng pagkansela ng order (kinakailangan):",
    请选择申请退款的原因必选: "Pakipili ang dahilan ng paghiling ng refund (kinakailangan):",
    留言: "Mensahe",
    请输入留言: "Mangyaring magpasok ng mensahe",
    没有帐户: "Walang account",
    钱包充值: "Mag-recharge ng wallet",
    输入您的文字: "Ilagay ang iyong text",
    商家登录: "Login ng merchant",
    有关此产品的任何查询: "Anumang mga katanungan tungkol sa produktong ito",
    产品名称: "Pangalan ng Produkto",
    你的问题: "Problema mo",
    白银店铺: "Tindahan ng pilak",
    铂金店铺: "Tindahan ng platinum",
    钻石店铺: "Tindahan ng brilyante",
    照片: "Larawan",
    已退货: "Ibinalik",
    邮寄状态: "Katayuan sa pag-mail",
    订单摘要: "Buod ng order",
    收件地址: "Address ng tatanggap",
    订购日期: "Petsa ng order",
    订单状态: "Katayuan ng Order",
    总订单金额: "Kabuuang halaga ng order",
    邮寄方式: "Paraan ng pagpapadala ng koreo",
    附加信息: "Karagdagang impormasyon",
    订单详细信息: "Mga detalye ng order",
    交货类型: "Uri ng paghahatid",
    进行评论: "Magkomento",
    已评论: "Nagkomento",
    订单金额: "Halaga ng binili",
    优惠券: "Kupon",
    统一运费: "Flat na bayad sa pagpapadala",
    送货地址: "Address ng Pagpapadala",
    评分: "Puntos",
    你的意见: "Ang iyong opinyon",
    匿名: "Anonymous",
    现金: "Cash",
    详情: "Mga Detalye",
    收货地址: "Address ng pagpapadala",
    暂时没有对话: "Wala pang usapan",
    你: "Ikaw",
    输入您的回复: "Ilagay ang iyong tugon",
    删除成功: "Matagumpay na natanggal",
    品牌: "Tatak",
    已缴纳的保证金: "Binayaran ang security deposit",
    黄金店铺: "Tindahan ng ginto",
    没有更多数据: "Wala nang data",
    站内信: "Mensahe ng site",
    系统通知: "Abiso ng system",
    邮箱: "Mail",
    手机号: "Numero ng telepono",
    营业执照: "lisensya sa negosyo",
    你的邮箱: "iyong mailbox",
    搜索结果: "Mga Resulta ng Paghahanap",
    系统公告: "abiso ng system",
    客服: "serbisyo sa customer",
    消息已撤回: 'Ang mensahe ay binawi',
    物流详情: 'Mga detalye ng logistik',
    充值: 'top up',
    提现: 'bawiin',
    信用分: 'marka ng kredito',
    余额: 'balanse',
    佣金: 'komisyon',
    继续购物: 'ipagpatuloy ang pamimili',
    订单结算: 'Pag-aayos ng order',
    加入对比: 'Idagdag sa paghahambing',
    佣金余额: "Balanse ng komisyon",
    刷新: "refresh",
    刷新成功: "Matagumpay ang pag-refresh",
    官网: "Opisyal na website",
    税号: 'Numero ng ID ng buwis',
    订单: 'Umorder',
    合计: "kabuuan",
    系统安全: "Seguridad ng system",
    Recharge_Money_Limit: 'Ang halaga ng recharge ay dapat nasa pagitan ng {min} at {max}',
    限时优惠: 'Limitadong oras na alok',
    高价回收: 'Pag-recycle ng mataas na presyo',
    姓名: 'Pangalan',
    商品订单号: 'Numero ng order ng produkto',
    商品在线回收: 'Pag-recycle ng produkto online',
    提交: 'isumite',
    回收记录: 'Mga tala sa pag-recycle',
    回收状态: 'Katayuan ng pag-recycle',
     回收价格: 'presyo ng recycle',
     纳税码: 'code ng buwis',
     买家登录: 'Mag-log in',
     买家注册: 'magparehistro',
     任務: 'Gawain',
     下单失败_请稍后重试: 'Nabigo ang order, subukan ulit mamaya',



     'language': '菲律宾',
 }
 ;
